import { render, staticRenderFns } from "./OutboundEdiResults.vue?vue&type=template&id=65a37000&scoped=true&"
import script from "./OutboundEdiResults.vue?vue&type=script&lang=js&"
export * from "./OutboundEdiResults.vue?vue&type=script&lang=js&"
import style0 from "./OutboundEdiResults.vue?vue&type=style&index=0&id=65a37000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a37000",
  null
  
)

/* custom blocks */
import block0 from "./OutboundEdiResults.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports